import React from 'react'

const WorkerTermsAndConditions = () => {
    return (
        <div>WorkerTermsAndConditions</div>
    )
}

export default WorkerTermsAndConditions